/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {NgModule} from '@angular/core';
import {SelectItem} from 'primeng/primeng';
import { DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule, ButtonModule, TabViewModule } from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';

import {SearchModule} from "../../component/search.component";

import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";

import {CommonModule, DatePipe} from "@angular/common";
import {TranslateServiceForm} from "../../translate/translate.service";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {Logger} from "angular2-logger/core"; // ADD THIS
import {ExDialogModule} from "../../component/dialog.component";
import { AuditLog } from '../../model/auditlog';
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {DomSanitizer} from '@angular/platform-browser';
import {BrowserDomAdapter} from '@angular/platform-browser/src/browser/browser_adapter';
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";




@Component({

  selector: 'auditlog',
  templateUrl: 'audit_log.html'
})
export class AuditLogComponent implements OnInit {
  @ViewChild("differ") el:ElementRef;
  @ViewChild("sp") sp_el:ElementRef

  totalRecord: number;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  excelIsTrue : boolean = true;
  sDate: string;
  eDate: string;
  isLike : string;

  // company_items : SelectItem[];
  // visitorType_items : SelectItem[];
  operation_items : SelectItem[];
  entityName_items : SelectItem[];
  searchTextDropBox : SelectItem[];
  searchTextIsDropBox : boolean;
  searchTextIsUse : boolean;

  searchText: string;
  searchId : string;
  pageMax:number =10;

  date : Date= new Date();
  datePipe : any = new DatePipe("en");

  addTitle : string = "자세히";
  addShow : boolean = false;
  addDialogWidth : number = 700
  selectLog : AuditLog;
  selecthPolicy : any;
  selecthCondition : any[] = [];
  selecthControl : any[] = [];

  auditPolicyShow : boolean = false;
  pre_id : number;
  next_id : number;
  appointedTitle : string = "";
  private translate:TranslateServiceForm;

  ngOnInit() {

    this.searchTextIsUse = false;
    this.getEntityName();
    let nDate = new Date();
    nDate.setDate(nDate.getDate()-15);
    this.sDate = this.datePipe.transform(nDate, 'yyyy-MM-dd')
    this.eDate = this.datePipe.transform(this.date, 'yyyy-MM-dd')
    this.getAuditLogList(0,10, "", "", this.sDate, this.eDate);
    // Document.getElementsByTagName('span').addEventListener('click',this.doSomething,false);
    //var spans = document.getElementsById('span');
    //console.log(spans);



    this.logger.warn("differ :", this.el);

  }

  pre_policyInfo() {
    if(this.pre_id != 0){
      this.auditPolicyShow = true;
      this.appointedTitle = "Previous Data";
      this.getAuditLogPolicy(this.pre_id);
      this.getAuditLogPolicyView(this.pre_id);
    }

  }

  next_policyInfo() {
    if(this.next_id != 0) {
      this.auditPolicyShow = true;
      this.appointedTitle = "Next Data";
      this.getAuditLogPolicy(this.next_id);
      this.getAuditLogPolicyView(this.next_id);
    }

  }

  constructor(private domAdapter : BrowserDomAdapter, private service : MamAdminService, private _translate: TranslateServiceForm, private logger : Logger, private sanitizer : DomSanitizer) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_RoleUser'), value: 'username'});
    this.searchIDs.push({label: this.translate.instant('LANG_AuditEntityName'), value: 'entityName'});
    this.searchIDs.push({label: this.translate.instant('LANG_AuditOperation'), value: 'operation'});

    this.operation_items = [];
    this.operation_items.push({label : '------------------------------', value : 'all'})
    this.operation_items.push({label: 'CREATE', value: 'CREATE'});
    this.operation_items.push({label: 'UPDATE', value: 'UPDATE'});
    this.operation_items.push({label: 'DELETE', value: 'DELETE'});

    this.dateIsTrue = true;

  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;

    if(!this.sDate || !this.eDate ) {
      alert(this.translate.instant('MESSAGE_SearchDate_Require'));
      return;
    }

    if(this.eDate < this.sDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }

    this.getAuditLogList(0,this.pageMax,this.searchText, this.searchId, this.sDate, this.eDate);

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      this.getAuditLogList(event.page, event.rows,this.searchText, this.searchId, this.sDate, this.eDate);
    } else {
      this.getAuditLogList(event.page, event.rows,"", "", this.sDate, this.eDate);
    }

  }

  getAuditLogList(page:number, max:number, search:string, field:string, start:string, end:string){
    this.service.getAuditLogList(page, max, search, field, start, end).subscribe(
        value => {

          this.logger.debug("audit list : " , value.content);
          this.table_list = value.content;
          this.totalRecord = value.totalElements;
          if(this.table_list) {
            this.table_list.forEach(log=> {
              log.entityName = this.translate.instant("Audit_" + log.entityName);
            });
          }
        },
        error=>{this.logger.error("-- error : " + error);},
        ()=>{}
    )
  }

  getEntityName() {
    this.service.getEntityName().subscribe(
        value => {
            this.table_list = value;
            this.logger.debug("entity :" , value);
        },
        error=>{this.logger.error("-- error : " + error);},
        ()=>{
          this.entityName_items = [];
          this.entityName_items.push({label : '------------------------------', value : ''})
          if(this.table_list) {
            this.table_list.forEach(log=> {
              this.logger.debug("log => ", log);
              this.entityName_items.push({label : this.translate.instant("Audit_" + log), value : log})
            })
          }
        }
    )
  }

  searchTextChange(data) {
    this.searchText = '';
    if(data == 'entityName') {
      this.searchTextDropBox = this.entityName_items;
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = true;
    } else if(data == 'operation') {
      this.searchTextDropBox = this.operation_items;
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = true;
    } else if(data == 'all' || !data) {
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = false;
    } else {
      this.searchTextIsUse = true;
      this.searchTextIsDropBox = false;
    }

  }
  excelExport(event){
    this.logger.debug(event);
    this.logger.debug(this.sDate);
    this.logger.debug(this.eDate);
    if(!this.sDate || !this.eDate) {
      alert(this.translate.instant('MESSAGE_Search_And_Out'));
      return;
    }
    var url = this.service.getUrl() + "/mgr/log/audit/excel";
    if(!this.searchId || this.searchId == "all") {
      url = url + "?start=" + this.sDate + "&end=" + this.eDate;
    } else{
      url = url + "?start=" + this.sDate + "&end=" + this.eDate +
      "&search_text=" + this.searchText + "&search_field=" + this.searchId;
    }

    window.open(url);
  }

  getAuditLogSyncView() {
    this.service.getAuditLogSyncView().subscribe(
        value => {
          this.logger.debug("value :", value);

        },
        error=>{this.logger.error("-- error : " + error);},
        ()=>{}
    )
  }

  getAuditLogPolicy(id:number) {
    this.service.getAuditLogPolicy(id).subscribe(
        value => {
          this.logger.debug("value :", value);
          this.selecthPolicy = value;

          //selecthControl : any[] = [];

        },
        error=>{console.error("-- error : " + error);},
        ()=>{}
    )
  }

  getAuditLogPolicyView(id:number) {
    this.service.getAuditLogPolicyView(id).subscribe(
        value => {
          this.logger.debug("value :", value);
          this.selecthCondition = value.condition;
          this.logger.debug("select h Condition : " , this.selecthCondition);
          if(this.selecthCondition.length > 0) {
            this.selecthCondition.forEach(condition => {
              this.logger.debug("condition -> " , condition);
              this.selecthControl = condition.controls;
              this.logger.debug("select h Control : " , this.selecthControl);
              if(this.selecthControl.length > 0 ) {
                this.selecthControl.forEach(control =>{
                  control.controlClass.name = this.translate.instant("MdmPolicyControlName_" + control.controlClass.name);
                  this.logger.debug("control -> ", control);
                });
              }
            })
          }

        },
        error=>{console.error("-- error : " + error);},
        ()=>{}
    )
  }

  getGroupTarget(policyId: number){
    this.service.getGroupTarget(policyId).subscribe(
        value => {
          this.logger.debug("group targer L: " , value);
        },
        error=>{console.error("-- error : " + error);},
        ()=>{}
    )
  }

  getPolicyTargetList(policyId : number, type : string, page:number, max:number) {
    this.service.getPolicyTargetList(policyId, type, page, max).subscribe(
        value => {
          this.logger.debug("getPolicyTargetList: " , value);
        },
        error=>{console.error("-- error : " + error);},
        ()=>{}
    )
  }

  selectLogDetail(data) {
    this.logger.debug("data :" , data);
     var pre_el = document.createElement('table');
     var next_el = document.createElement('table');
     pre_el.innerHTML = data.originalEntityView;
     next_el.innerHTML = data.differenceView;
     var pre_dom = this.domAdapter.getElementsByClassName(pre_el,"audit-detail")[0];
     var next_dom = this.domAdapter.getElementsByClassName(next_el,"audit-detail")[0];
     this.logger.debug("pre dom : " , pre_dom);
     this.logger.debug("next dom : " , next_dom);
     if(pre_dom && next_dom) {
        this.pre_id = Number(this.domAdapter.attributeMap(pre_dom).get('historyid'));
        this.next_id = Number(this.domAdapter.attributeMap(next_dom).get('historyid'));
        this.logger.debug("pre policy id :", this.pre_id);
        this.logger.debug("next policy id :", this.next_id);
     } else {
       this.pre_id = 0;
       this.next_id = 0;
     }



    //  this.getGroupTarget(this.historyPolicyId);
    //  this.getPolicyTargetList(this.historyPolicyId, "device", 0, 999);
    // data.originalEntityView = this.sanitizer.bypassSecurityTrustHtml(data.originalEntityView);
    // data.differenceView = this.sanitizer.bypassSecurityTrustHtml(data.differenceView);
    setTimeout(() => {
      this.selectLog = data;
      this.addShow = true;
    } , 200);

  }



}

@NgModule({
  imports: [ExDialogModule, ButtonModule, DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule,FormsModule,SearchModule, SearchDropBoxModule, MainPipeMoudle, TabViewModule, TranslatePipeMoudle],
  exports: [AuditLogComponent],
  declarations: [AuditLogComponent],
  providers: [MamAdminService, BrowserDomAdapter],
})
export class AuditLogModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/log/audit_log.ts